export default __webpack_public_path__ + "static/media/fabric4.e291c590.png";